module.exports = __webpack_public_path__ + "img/SmartToyOutlined.898939c3.svg";